import type { SocialBoostSettings } from '../@types/SocialBoost';
import type { Actions } from '../actions';
import {
  RCV_GET_SOCIAL_BOOST_SETTINGS,
  RCV_GET_SOCIAL_BOOST_SETTINGS_BRANCH,
  RCV_UPDATE_SOCIAL_BOOST_SETTINGS,
  RCV_UPDATE_SOCIAL_BOOST_SETTINGS_BRANCH,
  REQ_GET_SOCIAL_BOOST_SETTINGS,
  REQ_GET_SOCIAL_BOOST_SETTINGS_BRANCH,
  REQ_UPDATE_SOCIAL_BOOST_SETTINGS,
  REQ_UPDATE_SOCIAL_BOOST_SETTINGS_BRANCH,
  REQUEST_FAILED,
} from '../actions/social-boost';
import { requestStatus, responseStatus } from '../shared/statuses';

export interface SocialBoostState {
  requestStatus: number;
  responseStatus: number;
  settings: SocialBoostSettings | null;
  branchSettings: SocialBoostSettings | null;
}

const _initialState: SocialBoostState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  settings: null,
  branchSettings: null,
};

const socialBoostReducer = (
  state: SocialBoostState = _initialState,
  action: Actions,
): SocialBoostState => {
  switch (action.type) {
    case REQ_GET_SOCIAL_BOOST_SETTINGS:
      return {
        ...state,
        settings: null,
        requestStatus: requestStatus.FETCHING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_GET_SOCIAL_BOOST_SETTINGS:
      return {
        ...state,
        settings: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_UPDATE_SOCIAL_BOOST_SETTINGS:
      return {
        ...state,
        requestStatus: requestStatus.UPDATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_UPDATE_SOCIAL_BOOST_SETTINGS:
      return {
        ...state,
        settings: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_GET_SOCIAL_BOOST_SETTINGS_BRANCH:
      return {
        ...state,
        branchSettings: null,
        requestStatus: requestStatus.FETCHING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_GET_SOCIAL_BOOST_SETTINGS_BRANCH:
      return {
        ...state,
        branchSettings: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_UPDATE_SOCIAL_BOOST_SETTINGS_BRANCH:
      return {
        ...state,
        requestStatus: requestStatus.UPDATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_UPDATE_SOCIAL_BOOST_SETTINGS_BRANCH:
      return {
        ...state,
        branchSettings: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQUEST_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default socialBoostReducer;
